/**
 * First-run analytics prompt (ANALYTICS.md §5): analytics stay OFF until the player taps YES. Shown over the menus
 * (never during a match) until answered; the answer is remembered and changeable in Settings → GAMEPLAY.
 * `.hf-root` is `pointer-events:none` (only screens/overlays opt back in), so the banner must set `pointer-events:auto`
 * itself, and it sits above the sign-in gate (z 70) so its buttons stay clickable while the gate is up.
 */
import { consentSignal, optIn, optOut } from '@hf/client-core/analytics';
import { ui } from '@hf/client-core/ui-model/store';

export function ConsentPrompt() {
  const screen = ui.screen.value;
  if (consentSignal.value !== 'unknown' || screen === 'boot' || screen === 'match' || screen === 'versus') {
    return null;
  }
  return (
    <div
      class="hf-consent"
      role="dialog"
      aria-label="Share gameplay stats"
      style="position:fixed;left:0;right:0;bottom:0;z-index:80;pointer-events:auto;display:flex;flex-wrap:wrap;gap:12px;align-items:center;justify-content:center;padding:12px 16px;background:rgba(11,8,32,.94);color:#fff;font:600 14px Fredoka,sans-serif"
    >
      <span style="max-width:560px">
        Help improve Hand Egg? Share gameplay stats linked by a pseudonymous ID (no name, no chat, no ads). You can change this
        any time in Settings.
      </span>
      <button
        type="button"
        style="font:700 14px Bungee,sans-serif;padding:8px 14px;border:0;border-radius:8px;background:#ffd23f;color:#1b1440;cursor:pointer"
        onClick={() => optIn('first_run')}
      >
        YES, SHARE
      </button>
      <button
        type="button"
        style="font:700 14px Bungee,sans-serif;padding:8px 14px;border:0;border-radius:8px;background:#ffd23f;color:#1b1440;cursor:pointer"
        onClick={() => optOut('first_run')}
      >
        NO THANKS
      </button>
    </div>
  );
}
